import PropTypes from 'prop-types';
import React from 'react';
import {
  ROW_TYPE_FOUR_PRODUCTS,
  ROW_TYPE_FLEX_SERIES,
  ROW_TYPE_MULTI_STORY,
  ROW_TYPE_THREE_CHANNELS,
  ROW_TYPE_THREE_PREMIUM_CARDS,
  ROW_TYPE_CTA_BAR,
  ROW_TYPE_THREE_STANDARD_CARDS,
  ROW_TYPE_TWO_STANDARD_CARDS,
  ROW_TYPE_THREE_PRIME_CARDS,
  ROW_TYPE_ONE_PRIME_CARD,
  ROW_TYPE_FLEX_CATEGORY
} from '../../constants';
import Row from '../row/row';
import {get, map, flatMap} from 'lodash';
import { getModuleAdSizes } from '../../utils/ads/sizes';
import { isHomepageRefresh } from '../../utils/homepage_refresh/homepage';

export const MODULE_TYPE_PRODUCT_LIST = 'product_list';
export const MODULE_TYPE_RELATED_PRODUCTS = 'related_products';
export const MODULE_TYPE_SERIES = 'blog_series';
export const MODULE_TYPE_HERO = 'hero';
export const MODULE_TYPE_SHOPS_CATEGORY = 'shops_category';
export const MODULE_TYPE_FEED = 'feed';
export const MODULE_TYPE_HP_REFRESH_FEATURED_STORY = 'hp_refresh_featured_story';
export const MODULE_TYPE_HP_REFRESH_FEED = 'hp_refresh_feed';
export const MODULE_TYPE_HP_REFRESH_FEED_ADS = 'hp_refresh_feed_ads';
export const MODULE_TYPE_HP_REFRESH_SHOPS_CATEGORY = 'hp_refresh_shops_category';
export const MODULE_TYPE_HP_REFRESH_TRENDING_VIDEOS = 'hp_refresh_trending_videos';
export const MODULE_TYPE_HP_REFRESH_MOST_POPULAR = 'hp_refresh_most_popular';

const PASSTHROUGH_ROW_TYPES = [
  ROW_TYPE_FOUR_PRODUCTS,
  ROW_TYPE_FLEX_SERIES,
  ROW_TYPE_MULTI_STORY,
  ROW_TYPE_THREE_CHANNELS,
  ROW_TYPE_THREE_PREMIUM_CARDS,
  ROW_TYPE_CTA_BAR,
  ROW_TYPE_TWO_STANDARD_CARDS,
  ROW_TYPE_FLEX_CATEGORY
];

const getMobileRowType = ({ type: rowType, indexWithinModule: rowIndexInModule,
  indexWithinRow }, isHomepageRefresh, moduleType) => {

  if (PASSTHROUGH_ROW_TYPES.includes(rowType)) {
    return rowType;
  }

  const isRefreshFeedModule = [
    MODULE_TYPE_FEED,
    MODULE_TYPE_HP_REFRESH_FEED,
    MODULE_TYPE_HP_REFRESH_FEED_ADS
  ].includes(moduleType);

  // The first card (prime or standard) should render as a prime card except for the Feed module on the homepage refresh
  if (rowIndexInModule === 1
    && indexWithinRow === 1
    && (rowType === ROW_TYPE_THREE_PRIME_CARDS || rowType === ROW_TYPE_THREE_STANDARD_CARDS)
    && !(isRefreshFeedModule && isHomepageRefresh)
  ) {
    return ROW_TYPE_ONE_PRIME_CARD;
  }

  if (rowType === ROW_TYPE_THREE_PRIME_CARDS) {
    return ROW_TYPE_THREE_STANDARD_CARDS;
  }

  return rowType;
};

const toSingleCardRows = (rows) =>
  flatMap(rows, ({ cards, ...row }) =>
    map(cards, ({ indexWithinRow, mobileAdPosition, ...card }) => ({
      ...row,
      key: card.id,
      cards: [card],
      indexWithinRow,
      mobileAdPosition
    }))
  );

const rowsForMobile = (rows, type) => [
  MODULE_TYPE_PRODUCT_LIST,
  MODULE_TYPE_RELATED_PRODUCTS,
  MODULE_TYPE_SERIES,
  MODULE_TYPE_HERO,
  MODULE_TYPE_SHOPS_CATEGORY,
  MODULE_TYPE_HP_REFRESH_SHOPS_CATEGORY,
  MODULE_TYPE_HP_REFRESH_TRENDING_VIDEOS,
  MODULE_TYPE_HP_REFRESH_MOST_POPULAR
].includes(type) ? rows : toSingleCardRows(rows);

const MobileContentModule = ({
  adsState,
  archivesState,
  id,
  page_id,
  page_type,
  rows,
  title,
  type,
  channelCampaignBrandingImage,
  channelSubtitle
}, { location, edition_data }) => {
  const isRefresh = isHomepageRefresh(location, edition_data, true);
  return (
    <div>
      {
        map(rowsForMobile(rows, type), row => (
          <Row {...row}
            key={row.key || get(row, 'cards[0].id')}
            adPosition={row.mobileAdPosition}
            adSizes={getModuleAdSizes(type, 'mobile')}
            adsState={adsState}
            archivesState={archivesState}
            breakpoint="mobile"
            isHomepageRefresh={isRefresh}
            moduleID={id}
            moduleTitle={title}
            moduleType={type}
            page_id={page_id}
            page_type={page_type}
            type={getMobileRowType(row, isRefresh, type)}
            channelCampaignBrandingImage={channelCampaignBrandingImage}
            channelSubtitle={channelSubtitle}
          />
        ))
      }
    </div>
  );
};

MobileContentModule.propTypes = {
  adsState: PropTypes.object.isRequired,
  archivesState: PropTypes.object,
  id: PropTypes.number.isRequired,
  page_id: PropTypes.number.isRequired,
  page_type: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    rowID: PropTypes.number,
    indexWithinModule: PropTypes.number,
    moduleTitle: PropTypes.string,
    cards: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number }))
  })).isRequired,
  title: PropTypes.string,
  type: PropTypes.string,
  channelCampaignBrandingImage: PropTypes.string,
  channelSubtitle: PropTypes.string
};

MobileContentModule.defaultProps = {
  adsState: {},
  rows: []
};

MobileContentModule.contextTypes = {
  location: PropTypes.object,
  edition_data: PropTypes.object
};

export default MobileContentModule;
